// Module Name
export const name = 'selfService';

export const typeSelfService = {
    RESUME_SELFSERVICE: `${name}/RESUME_SELFSERVICE`,
    GET_SELFSERVICE_CONTRACT_INFO: `${name}/GET_SELFSERVICE_CONTRACT_INFO`,

    LOG_STEP_SELFSERVICE: `${name}/LOG_STEP_SELFSERVICE`,
    CREATE_SELFSERVICE_CONTRACT: `${name}/CREATE_SELFSERVICE_CONTRACT`,
    UPDATE_SELFSERVICE_CONTRACT: `${name}/UPDATE_SELFSERVICE_CONTRACT`,
    SIGN_SELFSERVICE_CONTRACT: `${name}/SIGN_SELFSERVICE_CONTRACT`,
};
